export default {
    createNewMember: 'สร้างสมาชิกใหม่',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    userName: 'ชื่อผู้ใช้งาน',
    password: 'รหัสผ่าน',
    emailAddress: 'อีเมล์',
    phoneNumber: 'เบอร์โทรศัพท์',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    incorrectPhoneNubmer: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    thisFieldIsExceededCharacters: 'ข้อความเกิน 255 ตัวอักษร',
    branch: 'สาขา',
    role: 'ตำแหน่ง',
    save: 'บันทึก',
    emailIsRequired: 'กรุณากรอกอีเมล์',
    invalidEmailFormat: 'รูปเเบบอีเมล์ไม่ถูกต้อง',
    emailIsExceededCharacters: 'อีเมล์เกิน 255 ตัวอักษร',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    updateUserInfo: 'แก้ไขข้อมูลผู้ใช้',
    userIsUpdate: 'ข้อมูลผู้ใช้ถูกอัปเดตแล้ว',
    userIsCreated: 'ผู้ใช้งานถูกสร้างแล้ว',
    cannotHaveSpace: 'กรุณากรอกข้อมูล(งดการใช้เครื่องหมายวรรคตอน)',
    cannotHaveSharp: 'ห้ามกรอกตัวอักษร #'
}
